// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { lazy, Suspense } from 'react';
import pagesContext from '../pages-context';
import ErrorBoundary from './error-boundary';
const pagesComponents = {};
export default function PageView({ pageId }) {
    if (!pagesComponents[pageId]) {
        pagesComponents[pageId] = lazy(() => pagesContext(`./${pageId}.page.tsx`));
    }
    const Page = pagesComponents[pageId];
    return (React.createElement(ErrorBoundary, { key: pageId },
        React.createElement(Suspense, { fallback: React.createElement("span", null, "Loading...") },
            React.createElement(Page, null))));
}
